export enum EPropertyUrl {
  PROPERTIES = 'properties',
  UPLOAD = 'upload',
  PREVIEW = 'preview-upload',
  UNITS = 'units',
  SEARCH = 'search',
  TYPES = 'types',
  TEMPLATE = 'template',
}
